import React, { useEffect, useState } from "react";
import Ordersdet from "./Ordersdet";
import Loadersspinners from "./Loaders/LoadersSpinners";
import { Baseurl } from "../constants/env";
import {useSelector} from 'react-redux' 


import axios from "axios";

const Orders = () => {
  const [product, setProduct] = useState([]);
  const [name, setName] = useState();
  const[loading,setLoading]=useState(false);
  const [change, setChange] = useState();
  const {userid} = useSelector((state)=>state.auth) 

  useEffect(() => {
    getorderdata();
  }, [change]);

  async function getorderdata() {
    setLoading(true)
    await axios
      .get(`${Baseurl}/placeorder?id=${userid}`, { withCredentials: true })
      .then((resp) => {
        setName(resp.data.username);
        setProduct(resp.data.productdata);
        setLoading(false)
      })
      .catch((e) => {
        console.log(e.message);
        setLoading(false)
      });
  }

  function getchange(resp) {
    setChange(resp);
  }

  return (
    <div>
      {product.length === 0 || loading ? 
      <div className=" bg-primary" style={{height:'100vh',flexGrow:'1'}}>

      <div className="container">
          <div className="row">
            <div className="col-md-12 text-center text-white">
              <div  style={{marginTop:'200px'}}>
             {loading ?  <div className="col-md-12 text-center text-white" ><Loadersspinners /></div> :  <h1>No Orders</h1>}
 
              </div>
            </div>
          </div>
        </div>
      </div> 
       : (
        <div className="bg-info" style={{height:'100vh',flexGrow:'1'}} >

        <div className="container ">
      <div className="row">
        <div className="col-md-12">
          <div className="mt-4 text-center"><h1>Your Orders</h1></div>
        </div>
      </div>
    </div>
          

          {product.map((item, index) => {
            return (
              
                <Ordersdet
                  key={index + 2}
                  index={index + 1}
                  id={item._id}
                  date={new Date(item.createdAt  * 1000).toLocaleString()}
                  name={`${item?.userid?.firstname} ${item?.userid?.lastname}`}
                  adress={item.adress}
                  mobile={item.mobile}
                  totalprice={item.totalprice}
                  removechange={getchange}
                />
             
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Orders;
